// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1600px) {
	.container {
		max-width: 1500px !important;
	}
}

/* \`xxl\` applies to x-large devices (large desktops, less than 1400px) */
@media (max-width: 1600px) {
	.banner-section .caption h1 {
		letter-spacing: 2.2px;
		font-size: 40px;
		font-weight: 900;
	}

	.banner-section .caption h5 {
		font-size: 18px;
		letter-spacing: 2px;
	}

	.banner-section .caption {
		padding-left: 100px;
	}

	#detail_banner .booking_card .my_booking_header {
		display: flex;
		justify-content: space-between;
	}

	#detail_banner .h4-tab-booking {
		font-size: 18px;
	}

	#detail_banner .btn_chat {
		width: 150px;
		font-size: 12px;
		padding: 2px 10px;
	}

	.p-feature-tag {
		font-size: 18px;
	}

	.feature_icon {
		gap: 10px !important;
		display: flex !important;
	}

	.row-card {
		display: flex;
		flex-direction: column;
	}

	.booked_date h3 {
		font-size: 13px;
	}

	.booked_date label {
		font-size: 13px;
	}
}

/* \`xl\` applies to large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
	.banner-section .caption {
		padding-left: 50px !important;
	}

	.banner-section .caption h5 {
		font-size: 16px;
		letter-spacing: 1px;
	}

	.banner-section .caption h1 {
		font-size: 34px;
		letter-spacing: 2.2px;
		margin: 15px 0px;
	}

	.banner-section .caption p {
		font-size: 20px;
	}

	.guest_serch_block {
		width: 95%;
	}

	.items_tab {
		max-width: 235px;
	}

	.content_tab {
		gap: 15px;
	}

	.card_us {
		padding: 10px;
	}

	.feature_icon_sec {
		flex-wrap: wrap;
		gap: 10px;
	}

	/* property Details */
	.side_detail_pic img {
		min-height: auto;
	}

	.side_detail_pic {
		width: 100%;
		min-height: auto;
	}

	.my_booking_header {
		gap: 10px;
	}

	.btn-more-info {
		min-width: 120px !important;
	}
	.text_height_p {
		min-height: 0px;
	}

}

/* \`lg\` applies to medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {

	.banner-section {
		min-height: auto;
		margin: 80px 0 0;
		padding-bottom: 0px
	}

	.banner-section .pattern {
		display: none;
	}

	.banner-section .caption {
		padding: 30px 0 0px !important;
		margin-top: 0 !important;
		max-width: 100%;
	}

	.banner-section .caption p {
		font-size: 30px;
		line-height: 50px;
	}

	.banner-section .banner-img {
		width: 100% !important;
		height: auto !important;
	}

	.inner-banner-section {
		min-height: 310px;
		margin: 123px 0 0;
	}

	.guest_serch_block {
		width: 95%;
		height: auto;
		bottom: 70%;
		transform: translate(-50%, 100%);
	}

	.content_tab {
		gap: 5px;
	}

	/* Proertey Details */
	.feature_icon_sec {
		align-items: flex-start;
		gap: 15px;
		flex-wrap: wrap;
	}

	.contact_content h4 {
		margin: 10px 0px;
	}

	/* Searchbox */
	.properties_search_sec,
	.tab_top_btn {
		display: flex;
		align-items: flex-start;
		flex-direction: column;
	}

	.filter_block {
		border: none;
	}

	.btn-more-info {
		min-width: 94px !important;
	}

	.btn_sec_card {
		gap: 5px
	}

	.btn-chat-info {
		min-width: 90px;
	}

}

/* \`md\` applies to small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
	.guest_serch_block {
		width: 95%;
		height: auto;
		bottom: 93%;
	}

	.items_tab {
		max-width: 100%;
		width: 100%;
	}

	.items_tab h4 {
		font-size: 17px;
		margin-bottom: 5px;
	}

	.items_tab p {
		font-size: 14px;
		line-height: 15px;
	}

	.why_us_card {
		display: flex;
		flex-direction: column;
	}

	.feature-list-cs {
		display: flex !important;
		flex-direction: column !important;
	}

	/* Properties Page Css */

	.filter_content .home_card {
		flex-direction: column !important;
	}

	.inner_banner {
		min-height: 250px;
		margin-top: 100px;
	}

	.my_booking_header {
		width: 100%;
		flex-direction: column;
		gap: 10px;
	}

	.booking_card_header {
		padding: 15px 0px;
	}

	.booking_dollar p {
		font-size: 16px;
	}

	.booking_dollar p span {
		font-size: 16px !important;
	}

	.total label {
		font-size: 20px;
	}

	.css-heg063-MuiTabs-flexContainer {
		display: flex !important;
		flex-direction: column !important;
	}

	.card_header_small {
		display: flex;
		flex-direction: column !important;
	}

}

@media (max-width: 575.98px) {

	.banner-section .caption p {
		font-size: 20px;
		line-height: 36px;
	}

	.filter_header {
		display: flex !important;
		flex-wrap: wrap !important;
	}

	.filter_header_btns {
		display: flex !important;
		flex-wrap: wrap !important;
	}

	.row-card-booking {
		display: flex;
		flex-direction: column !important;
	}

	.card_heading_block {
		display: flex;
		/* flex-direction: column; */
		align-items: unset !important;
	}

	.date_input_field {
		min-width: 30%;
		font-size: 11px;
	}

	.my_booking_header {
		display: flex !important;
		/* justify-content: space-between !important; */
		flex-direction: row !important;
		flex-wrap: nowrap !important;
	}

	.h4-tab-booking {
		font-size: 12px !important;
	}

	#detail_banner .btn_chat {
		width: 123px;
		font-size: 10px;
		padding: 0px 5px;
	}

}

@media (max-width: 440px) {
	.banner-section .caption h5 {
		font-size: 14px;
		letter-spacing: 2px;
	}

	.banner-section .caption h1 {
		font-size: 28px;
	}

	.banner-section .caption p {
		font-size: 20px;
		line-height: 30px;
	}

	.guest_serch_block {
		display: none;
	}

	.h2_tag_related {
		font-size: 20px !important;
	}

	.btn_pending {
		width: 113px;
		height: 35px;
	}
	.btn_accepted {
		width: 113px;
		height: 35px;
	}
}

@media (max-width: 375px) {
	.card_heading_block span {
		font-size: 16px;
	}

	.icons_technical {
		display: none !important;
	}

	.online_condiiton {
		display: flex;
	}

	.card_heading_block h2 {
		font-size: 14px !important;
	}

}

@media only screen and (min-width: 768px) and (max-width: 900px) {
	.btn_pending {
		width: 110px;
		height: 35px;
	}

	.btn_accepted {
		width: 110px;
		height: 35px;
	}

	.badge_btn {
		margin-bottom: 10px;
	}

	.card_heading_block h2 {
		font-size: 13px !important;
	}

	.card_heading_block span {
		font-size: 15px;
	}

	.card_header_small {
		display: flex !important;
		flex-direction: column !important;
		align-items: unset;
	}

	.home_card_booking {
		display: block !important;
	}
}

@media only screen and (min-width: 1000px) and (max-width: 1100px) {
	.card_us {
		gap: 10px
	}

	#detail_banner .h4-tab-booking {
		font-size: 13px !important;
	}

	.quality_img {
		height: 130px !important;
	}

	.div_bottom {
		margin-bottom: 10px;
	}

	.h2_div_property {
		margin-bottom: 0px !important;
		font-size: 11px !important;
	}

	h2.h2_div_property {
		margin-bottom: 0px !important;
		font-size: 11px !important;
	}

	h2.h2_div_property_first {
		margin-bottom: 0px !important;
		font-size: 16px !important;
	}

	.h2_div_property_first {
		margin-bottom: 0px !important;
		font-size: 16px !important;
	}

	.booking_dollar p {
		font-size: 16px;
	}

	.star_min {
		height: 20px !important;
		width: 20px !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/userpenal/styles/responsive.css"],"names":[],"mappings":"AAAA;CACC;EACC,4BAA4B;CAC7B;AACD;;AAEA,wEAAwE;AACxE;CACC;EACC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,8BAA8B;CAC/B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,oBAAoB;EACpB,wBAAwB;CACzB;;CAEA;EACC,aAAa;EACb,sBAAsB;CACvB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA,+DAA+D;AAC/D;CACC;EACC,6BAA6B;CAC9B;;CAEA;EACC,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,qBAAqB;EACrB,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,eAAe;EACf,SAAS;CACV;;CAEA,qBAAqB;CACrB;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,2BAA2B;CAC5B;CACA;EACC,eAAe;CAChB;;AAED;;AAEA,8DAA8D;AAC9D;;CAEC;EACC,gBAAgB;EAChB,gBAAgB;EAChB;CACD;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,8BAA8B;EAC9B,wBAAwB;EACxB,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,sBAAsB;EACtB,uBAAuB;CACxB;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gCAAgC;CACjC;;CAEA;EACC,QAAQ;CACT;;CAEA,qBAAqB;CACrB;EACC,uBAAuB;EACvB,SAAS;EACT,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA,cAAc;CACd;;EAEC,aAAa;EACb,uBAAuB;EACvB,sBAAsB;CACvB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC;CACD;;CAEA;EACC,eAAe;CAChB;;AAED;;AAEA,sEAAsE;AACtE;CACC;EACC,UAAU;EACV,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,sBAAsB;CACvB;;CAEA;EACC,wBAAwB;EACxB,iCAAiC;CAClC;;CAEA,wBAAwB;;CAExB;EACC,iCAAiC;CAClC;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,sBAAsB;EACtB,SAAS;CACV;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,wBAAwB;EACxB,iCAAiC;CAClC;;CAEA;EACC,aAAa;EACb,iCAAiC;CAClC;;AAED;;AAEA;;CAEC;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,wBAAwB;EACxB,0BAA0B;CAC3B;;CAEA;EACC,wBAAwB;EACxB,0BAA0B;CAC3B;;CAEA;EACC,aAAa;EACb,iCAAiC;CAClC;;CAEA;EACC,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;CAC9B;;CAEA;EACC,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,wBAAwB;EACxB,+CAA+C;EAC/C,8BAA8B;EAC9B,4BAA4B;CAC7B;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,gBAAgB;CACjB;;AAED;;AAEA;CACC;EACC,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,YAAY;EACZ,YAAY;CACb;CACA;EACC,YAAY;EACZ,YAAY;CACb;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,0BAA0B;CAC3B;;AAED;;AAEA;CACC;EACC,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;CACnB;;CAEA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC;CACD;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,6BAA6B;EAC7B,0BAA0B;CAC3B;;CAEA;EACC,6BAA6B;EAC7B,0BAA0B;CAC3B;;CAEA;EACC,6BAA6B;EAC7B,0BAA0B;CAC3B;;CAEA;EACC,6BAA6B;EAC7B,0BAA0B;CAC3B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,uBAAuB;EACvB,sBAAsB;CACvB;AACD","sourcesContent":["@media (min-width: 1600px) {\n\t.container {\n\t\tmax-width: 1500px !important;\n\t}\n}\n\n/* `xxl` applies to x-large devices (large desktops, less than 1400px) */\n@media (max-width: 1600px) {\n\t.banner-section .caption h1 {\n\t\tletter-spacing: 2.2px;\n\t\tfont-size: 40px;\n\t\tfont-weight: 900;\n\t}\n\n\t.banner-section .caption h5 {\n\t\tfont-size: 18px;\n\t\tletter-spacing: 2px;\n\t}\n\n\t.banner-section .caption {\n\t\tpadding-left: 100px;\n\t}\n\n\t#detail_banner .booking_card .my_booking_header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t#detail_banner .h4-tab-booking {\n\t\tfont-size: 18px;\n\t}\n\n\t#detail_banner .btn_chat {\n\t\twidth: 150px;\n\t\tfont-size: 12px;\n\t\tpadding: 2px 10px;\n\t}\n\n\t.p-feature-tag {\n\t\tfont-size: 18px;\n\t}\n\n\t.feature_icon {\n\t\tgap: 10px !important;\n\t\tdisplay: flex !important;\n\t}\n\n\t.row-card {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t.booked_date h3 {\n\t\tfont-size: 13px;\n\t}\n\n\t.booked_date label {\n\t\tfont-size: 13px;\n\t}\n}\n\n/* `xl` applies to large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n\t.banner-section .caption {\n\t\tpadding-left: 50px !important;\n\t}\n\n\t.banner-section .caption h5 {\n\t\tfont-size: 16px;\n\t\tletter-spacing: 1px;\n\t}\n\n\t.banner-section .caption h1 {\n\t\tfont-size: 34px;\n\t\tletter-spacing: 2.2px;\n\t\tmargin: 15px 0px;\n\t}\n\n\t.banner-section .caption p {\n\t\tfont-size: 20px;\n\t}\n\n\t.guest_serch_block {\n\t\twidth: 95%;\n\t}\n\n\t.items_tab {\n\t\tmax-width: 235px;\n\t}\n\n\t.content_tab {\n\t\tgap: 15px;\n\t}\n\n\t.card_us {\n\t\tpadding: 10px;\n\t}\n\n\t.feature_icon_sec {\n\t\tflex-wrap: wrap;\n\t\tgap: 10px;\n\t}\n\n\t/* property Details */\n\t.side_detail_pic img {\n\t\tmin-height: auto;\n\t}\n\n\t.side_detail_pic {\n\t\twidth: 100%;\n\t\tmin-height: auto;\n\t}\n\n\t.my_booking_header {\n\t\tgap: 10px;\n\t}\n\n\t.btn-more-info {\n\t\tmin-width: 120px !important;\n\t}\n\t.text_height_p {\n\t\tmin-height: 0px;\n\t}\n\n}\n\n/* `lg` applies to medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n\n\t.banner-section {\n\t\tmin-height: auto;\n\t\tmargin: 80px 0 0;\n\t\tpadding-bottom: 0px\n\t}\n\n\t.banner-section .pattern {\n\t\tdisplay: none;\n\t}\n\n\t.banner-section .caption {\n\t\tpadding: 30px 0 0px !important;\n\t\tmargin-top: 0 !important;\n\t\tmax-width: 100%;\n\t}\n\n\t.banner-section .caption p {\n\t\tfont-size: 30px;\n\t\tline-height: 50px;\n\t}\n\n\t.banner-section .banner-img {\n\t\twidth: 100% !important;\n\t\theight: auto !important;\n\t}\n\n\t.inner-banner-section {\n\t\tmin-height: 310px;\n\t\tmargin: 123px 0 0;\n\t}\n\n\t.guest_serch_block {\n\t\twidth: 95%;\n\t\theight: auto;\n\t\tbottom: 70%;\n\t\ttransform: translate(-50%, 100%);\n\t}\n\n\t.content_tab {\n\t\tgap: 5px;\n\t}\n\n\t/* Proertey Details */\n\t.feature_icon_sec {\n\t\talign-items: flex-start;\n\t\tgap: 15px;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.contact_content h4 {\n\t\tmargin: 10px 0px;\n\t}\n\n\t/* Searchbox */\n\t.properties_search_sec,\n\t.tab_top_btn {\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tflex-direction: column;\n\t}\n\n\t.filter_block {\n\t\tborder: none;\n\t}\n\n\t.btn-more-info {\n\t\tmin-width: 94px !important;\n\t}\n\n\t.btn_sec_card {\n\t\tgap: 5px\n\t}\n\n\t.btn-chat-info {\n\t\tmin-width: 90px;\n\t}\n\n}\n\n/* `md` applies to small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n\t.guest_serch_block {\n\t\twidth: 95%;\n\t\theight: auto;\n\t\tbottom: 93%;\n\t}\n\n\t.items_tab {\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t}\n\n\t.items_tab h4 {\n\t\tfont-size: 17px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.items_tab p {\n\t\tfont-size: 14px;\n\t\tline-height: 15px;\n\t}\n\n\t.why_us_card {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t.feature-list-cs {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column !important;\n\t}\n\n\t/* Properties Page Css */\n\n\t.filter_content .home_card {\n\t\tflex-direction: column !important;\n\t}\n\n\t.inner_banner {\n\t\tmin-height: 250px;\n\t\tmargin-top: 100px;\n\t}\n\n\t.my_booking_header {\n\t\twidth: 100%;\n\t\tflex-direction: column;\n\t\tgap: 10px;\n\t}\n\n\t.booking_card_header {\n\t\tpadding: 15px 0px;\n\t}\n\n\t.booking_dollar p {\n\t\tfont-size: 16px;\n\t}\n\n\t.booking_dollar p span {\n\t\tfont-size: 16px !important;\n\t}\n\n\t.total label {\n\t\tfont-size: 20px;\n\t}\n\n\t.css-heg063-MuiTabs-flexContainer {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column !important;\n\t}\n\n\t.card_header_small {\n\t\tdisplay: flex;\n\t\tflex-direction: column !important;\n\t}\n\n}\n\n@media (max-width: 575.98px) {\n\n\t.banner-section .caption p {\n\t\tfont-size: 20px;\n\t\tline-height: 36px;\n\t}\n\n\t.filter_header {\n\t\tdisplay: flex !important;\n\t\tflex-wrap: wrap !important;\n\t}\n\n\t.filter_header_btns {\n\t\tdisplay: flex !important;\n\t\tflex-wrap: wrap !important;\n\t}\n\n\t.row-card-booking {\n\t\tdisplay: flex;\n\t\tflex-direction: column !important;\n\t}\n\n\t.card_heading_block {\n\t\tdisplay: flex;\n\t\t/* flex-direction: column; */\n\t\talign-items: unset !important;\n\t}\n\n\t.date_input_field {\n\t\tmin-width: 30%;\n\t\tfont-size: 11px;\n\t}\n\n\t.my_booking_header {\n\t\tdisplay: flex !important;\n\t\t/* justify-content: space-between !important; */\n\t\tflex-direction: row !important;\n\t\tflex-wrap: nowrap !important;\n\t}\n\n\t.h4-tab-booking {\n\t\tfont-size: 12px !important;\n\t}\n\n\t#detail_banner .btn_chat {\n\t\twidth: 123px;\n\t\tfont-size: 10px;\n\t\tpadding: 0px 5px;\n\t}\n\n}\n\n@media (max-width: 440px) {\n\t.banner-section .caption h5 {\n\t\tfont-size: 14px;\n\t\tletter-spacing: 2px;\n\t}\n\n\t.banner-section .caption h1 {\n\t\tfont-size: 28px;\n\t}\n\n\t.banner-section .caption p {\n\t\tfont-size: 20px;\n\t\tline-height: 30px;\n\t}\n\n\t.guest_serch_block {\n\t\tdisplay: none;\n\t}\n\n\t.h2_tag_related {\n\t\tfont-size: 20px !important;\n\t}\n\n\t.btn_pending {\n\t\twidth: 113px;\n\t\theight: 35px;\n\t}\n\t.btn_accepted {\n\t\twidth: 113px;\n\t\theight: 35px;\n\t}\n}\n\n@media (max-width: 375px) {\n\t.card_heading_block span {\n\t\tfont-size: 16px;\n\t}\n\n\t.icons_technical {\n\t\tdisplay: none !important;\n\t}\n\n\t.online_condiiton {\n\t\tdisplay: flex;\n\t}\n\n\t.card_heading_block h2 {\n\t\tfont-size: 14px !important;\n\t}\n\n}\n\n@media only screen and (min-width: 768px) and (max-width: 900px) {\n\t.btn_pending {\n\t\twidth: 110px;\n\t\theight: 35px;\n\t}\n\n\t.btn_accepted {\n\t\twidth: 110px;\n\t\theight: 35px;\n\t}\n\n\t.badge_btn {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.card_heading_block h2 {\n\t\tfont-size: 13px !important;\n\t}\n\n\t.card_heading_block span {\n\t\tfont-size: 15px;\n\t}\n\n\t.card_header_small {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column !important;\n\t\talign-items: unset;\n\t}\n\n\t.home_card_booking {\n\t\tdisplay: block !important;\n\t}\n}\n\n@media only screen and (min-width: 1000px) and (max-width: 1100px) {\n\t.card_us {\n\t\tgap: 10px\n\t}\n\n\t#detail_banner .h4-tab-booking {\n\t\tfont-size: 13px !important;\n\t}\n\n\t.quality_img {\n\t\theight: 130px !important;\n\t}\n\n\t.div_bottom {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.h2_div_property {\n\t\tmargin-bottom: 0px !important;\n\t\tfont-size: 11px !important;\n\t}\n\n\th2.h2_div_property {\n\t\tmargin-bottom: 0px !important;\n\t\tfont-size: 11px !important;\n\t}\n\n\th2.h2_div_property_first {\n\t\tmargin-bottom: 0px !important;\n\t\tfont-size: 16px !important;\n\t}\n\n\t.h2_div_property_first {\n\t\tmargin-bottom: 0px !important;\n\t\tfont-size: 16px !important;\n\t}\n\n\t.booking_dollar p {\n\t\tfont-size: 16px;\n\t}\n\n\t.star_min {\n\t\theight: 20px !important;\n\t\twidth: 20px !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
